import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-chart-bar-icon',
  templateUrl: 'chart-bar-icon.component.html'
})
export class ChartBarIconComponent {
  constructor() {}
}
